import createBottomAddonComponent from "../../../ButtonCell/components/BottomAddon/fabric";
import createLabelComponent from "../../../ButtonCell/components/Label/fabric";
import createSubtitleComponent from "../../../ButtonCell/components/Subtitle/fabric";
import createValueComponent from "../../../ButtonCell/components/Value/fabric";
import { BUTTON_CELL_SCHEVRON_DISPLAY_NAME } from "../../utils/core";

export const Label = createLabelComponent(BUTTON_CELL_SCHEVRON_DISPLAY_NAME);
export const Subtitle = createSubtitleComponent(
    BUTTON_CELL_SCHEVRON_DISPLAY_NAME,
);
export const Value = createValueComponent(BUTTON_CELL_SCHEVRON_DISPLAY_NAME);
export const BottomAddon = createBottomAddonComponent(
    BUTTON_CELL_SCHEVRON_DISPLAY_NAME,
);
